(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["canta-holiday-promo"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const trigger = event.target.closest('[data-canta-gift-scroll]');
  if (!trigger) return;
  const productSection = trigger.closest('.shopify-section') || document;
  const gift = productSection.querySelector('.canta-gift-card') || document.querySelector('.canta-gift-card');
  if (!gift) return;
  gift.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["canta-included-gift"] && !Shopify.designMode) return;
  try {
    (function () {
  var startDay = Date.UTC(2026, 9, 30) / 86400000;

  function updateGiftBalances(root) {
    var cards = root.querySelectorAll('.canta-gift-card[data-canta-gift-base]');
    var elapsedDays = Math.max(0, Math.floor(Date.now() / 86400000) - startDay);

    cards.forEach(function (card) {
      var base = Number(card.dataset.cantaGiftBase);
      if (!Number.isFinite(base)) return;

      var remaining = Math.max(0, base * Math.pow(0.99, elapsedDays));
      var display = elapsedDays === 0 ? String(base) : remaining.toFixed(1);
      var track = card.querySelector('.canta-gift-card__track');
      var fill = card.querySelector('.canta-gift-card__fill');
      var number = card.querySelector('.canta-gift-card__remaining strong');

      if (track) track.setAttribute('aria-valuenow', display);
      if (fill) fill.style.width = display + '%';
      if (number) number.textContent = display + '%';
    });
  }

  function refreshAll() {
    updateGiftBalances(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll, { once: true });
  } else {
    refreshAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    updateGiftBalances(event.target);
  });
  window.setInterval(refreshAll, 60000);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["canta-price-guarantee"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('canta-price-guarantee')){
  customElements.define('canta-price-guarantee',class extends HTMLElement{
    connectedCallback(){
      if(this.guaranteeReady)return;
      this.guaranteeReady=true;
      const trigger=this.querySelector('[data-guarantee-open]');
      const dialog=this.querySelector('dialog');
      const close=this.querySelector('[data-guarantee-close]');
      if(!trigger||!dialog||!close)return;
      trigger.addEventListener('click',()=>dialog.showModal());
      close.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{
        const bounds=dialog.getBoundingClientRect();
        if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();
      });
      dialog.addEventListener('close',()=>trigger.focus());
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["canta-price-savings"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('canta-price-savings')) {
  customElements.define('canta-price-savings', class extends HTMLElement {
    connectedCallback() {
      this.form = document.forms[this.getAttribute('form')];
      this.label = this.querySelector('[data-savings-label]');
      this.savings = JSON.parse(this.querySelector('[data-savings-variants]').textContent);
      this.onVariantChange = event => {
        const amount = this.savings[String(event.detail.variant?.id)];
        this.hidden = !amount;
        if (amount) this.label.textContent = this.dataset.labelTemplate.replace('__AMOUNT__', amount);
      };
      this.form?.addEventListener('variant:change', this.onVariantChange);
    }
    disconnectedCallback() {
      this.form?.removeEventListener('variant:change', this.onVariantChange);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
